
import React, { useState } from "react";
import { MessageCircle, CheckCircle } from "lucide-react";
import { RESTAURANT_INFO } from "../constants";

const Saran: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    type: "Saran",
    message: "",
  });
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = `Halo Admin Hisana Padang, saya ${formData.name} ingin memberikan ${formData.type.toUpperCase()}: ${formData.message}`;
    window.open(
      `${RESTAURANT_INFO.whatsappLink}?text=${encodeURIComponent(text)}`,
      "_blank",
    );
    setIsSent(true);
    setTimeout(() => {
      setIsSent(false);
      setFormData({ name: "", type: "Saran", message: "" });
    }, 3000);
  };

  return (
    <section className="py-24 bg-[#ee1d23] text-white relative overflow-hidden" aria-labelledby="saran-title">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-400/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="space-y-8 text-center lg:text-left">
          <h2 id="saran-title" className="text-3xl sm:text-5xl md:text-6xl font-serif font-black leading-tight">
            Punya Saran atau Masukan <br className="hidden sm:block" /> Untuk
            Hisana Padang?
          </h2>
          <p className="text-sm sm:text-lg opacity-90 max-w-xl mx-auto lg:mx-0 font-medium leading-relaxed">
            Kami sangat menghargai setiap masukan Anda untuk terus meningkatkan
            kualitas pelayanan kami. Isi formulir di samping untuk mengirimkan
            suara Anda langsung ke admin kami.
          </p>
        </div>

        <div className="bg-white rounded-[2.5rem] p-8 sm:p-10 shadow-2xl text-slate-900 animate-scale-in">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <label htmlFor="saran-name" className="text-[10px] font-black uppercase text-slate-500 tracking-widest ml-1">
                Nama Anda
              </label>
              <input
                id="saran-name"
                required
                value={formData.name}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, name: e.target.value }))
                }
                placeholder="Masukkan nama lengkap"
                className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:ring-2 focus:ring-[#ee1d23] outline-none transition-all"
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="saran-type" className="text-[10px] font-black uppercase text-slate-500 tracking-widest ml-1">
                Jenis Masukan
              </label>
              <select
                id="saran-type"
                value={formData.type}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, type: e.target.value }))
                }
                className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:ring-2 focus:ring-[#ee1d23] outline-none transition-all font-bold min-h-[52px]"
              >
                <option value="Saran">Saran</option>
                <option value="Kritik">Kritik</option>
                <option value="Apresiasi">Apresiasi</option>
                <option value="Lainnya">Lainnya</option>
              </select>
            </div>
            <div className="space-y-2">
              <label htmlFor="saran-message" className="text-[10px] font-black uppercase text-slate-500 tracking-widest ml-1">
                Pesan Anda
              </label>
              <textarea
                id="saran-message"
                required
                value={formData.message}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, message: e.target.value }))
                }
                placeholder="Tuliskan masukan Anda di sini..."
                className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:ring-2 focus:ring-[#ee1d23] outline-none transition-all h-32 resize-none font-medium"
              />
            </div>
            <button
              type="submit"
              className={`w-full py-5 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl transition-all flex items-center justify-center gap-3 min-h-[52px] ${isSent ? "bg-green-600 text-white" : "bg-[#ee1d23] text-white hover:bg-[#d1191e]"}`}
            >
              {isSent ? (
                <>
                  <CheckCircle size={18} aria-hidden="true" /> BERHASIL TERKIRIM
                </>
              ) : (
                <>
                  <MessageCircle size={18} aria-hidden="true" /> KIRIM KE ADMIN
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Saran;
